import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TrainingRequirement } from '../models/training-requirement';
import { TrainingRequirementService } from '../services/training-requirement.service';
import { UserListLookup } from '../../shared/models/users/user-list-lookup';
import { CreateTrainingRequirementRequest } from '../models/create-training-requirement-request';
import { MessageService } from 'primeng/api';
import { SharedConstants } from '../../shared/constants/shared-constants';

@Component({
  selector: 'app-training-requirement-slider',
  templateUrl: './training-requirement-slider.component.html',
  styleUrls: ['./training-requirement-slider.component.scss']
})
export class TrainingRequirementSliderComponent {
  @Output() isCreateTrSliderActive = new EventEmitter<boolean>();
  @Input() isCreateTrSliderOpen: boolean = false;
  @Input() trainingRequirement : TrainingRequirement = new TrainingRequirement();
  topBarTitle: string = 'Create Training Requirement';
  userList : UserListLookup[] = [];
  valueField: string = 'name';
  labelField: string = 'name';
  mandatoryFields = {users : false};
  selectedUsers : any = [];
  usersWithRemovedTrainingItemStatus : string[] = [];
  createTrainingRequirementRequest : CreateTrainingRequirementRequest = new CreateTrainingRequirementRequest();
  validInput : boolean = false;

  constructor(private trainingRequirementService: TrainingRequirementService,
    private messageService: MessageService
  ) {

  }

  ngOnInit(): void {
    this.initialize();
  }

  initialize() : void {
    // Call the service method and subscribe to the result
    this.trainingRequirementService.getTrainingRequirementUsersLookUp(this.trainingRequirement)
      .subscribe(
        (response) => {
          this.userList = response;  // Populate userList with the response data
        },
        (error) => {
          console.error('Error fetching user list:', error);  // Handle error
        }
      );
  }

  closeCreateTrainingRequirementSlider = () => {
    this.isCreateTrSliderOpen = false;
    this.resetSlider();
    this.isCreateTrSliderActive.emit(false);
  }

  createTrainingRequirement = () => { 
    this.validateUserInput();
    if (this.validInput) { 
    this.createTrainingRequirementRequest.trainingRequirement = this.trainingRequirement;
    this.createTrainingRequirementRequest.users = this.selectedUsers;
    this.trainingRequirementService.createTrainingRequirementForUsers(this.createTrainingRequirementRequest)
      .subscribe(
        (response) => {
          this.usersWithRemovedTrainingItemStatus = response;  // Populate usersWithRemovedTrainingItemStatus with the response data
          if (this.usersWithRemovedTrainingItemStatus.length > 0) {
            let removedItems = this.usersWithRemovedTrainingItemStatus.join(", ");
            this.messageService.add({
              severity: SharedConstants.Severity_Error,
              summary: SharedConstants.CreateTrainingRequirement_Course_ValidationMessage,
              detail: removedItems,
              sticky: true
            });
          }
          else {
            this.messageService.add({
              severity: SharedConstants.Severity_Success,
              summary: SharedConstants.CreateTrainingRequirement_SuccessMessage,
              sticky: false
            });

          }
        },
        (error) => {
          console.error('Error fetching user list:', error);  // Handle error
        }
      );
    this.isCreateTrSliderOpen = false;
    this.resetSlider();
    this.isCreateTrSliderActive.emit(false);
    }
  }

  validateUserInput = () => {
    if (this.selectedUsers.length === 0)
    {
      this.validInput = false;
    }
    else {
      this.validInput = true;
    }
  }

  resetSlider = () => {
    this.userList = [];
    this.selectedUsers = [];
    this.validInput = false;
  }
}
